
export function Lottie(props) {
    // console.log('props', props)
    return {
        $template: '#lottie-template',
        endFrame: props.endFrame,
    }
}
